import ReactInputMastk from 'react-input-mask';
import type { ClipboardEvent } from 'react';

import * as Styled from './styles';

export default function Input({ label, name, errors, type, mask, register, errorMessage, min, patt, required, value, defaultValue, ...rest }: any) {
    const normalizedInputType = type || 'text';
    const normalizedDefaultValue = defaultValue === undefined || defaultValue === null
        ? ''
        : String(defaultValue);
    const normalizedLabel = typeof label === 'string'
        ? label.replace(/\s*\*+\s*/g, ' ').replace(/\s+/g, ' ').trim()
        : label;

    const maskedMinLengthRule = mask && typeof min === 'number'
        ? {
            minLength: {
                value: min,
                message: 'Preencha o campo completo'
            }
        }
        : {};

    const textMinLengthRule = !mask && typeof min === 'number' && min > 1
        ? {
            minLength: {
                value: min,
                message: errorMessage
            }
        }
        : {};

    function formatMaskedValue(rawValue: string, currentMask: string) {
        const digits = rawValue.replace(/\D/g, '');
        let digitIndex = 0;
        let formattedValue = '';

        for (const char of currentMask) {
            if (char === '9') {
                if (digitIndex >= digits.length) {
                    break;
                }

                formattedValue += digits[digitIndex];
                digitIndex += 1;
                continue;
            }

            if (digitIndex < digits.length) {
                formattedValue += char;
            }
        }

        return formattedValue;
    }

    function handlePaste(event: ClipboardEvent<HTMLInputElement>) {
        if (!mask) {
            rest.onPaste?.(event);
            return;
        }

        const clipboardValue = event.clipboardData?.getData('text') || '';
        const hasDigits = clipboardValue.replace(/\D/g, '').length > 0;

        if (!hasDigits) {
            rest.onPaste?.(event);
            return;
        }

        event.preventDefault();

        const formattedValue = formatMaskedValue(clipboardValue, mask);
        const nativeValueSetter = Object.getOwnPropertyDescriptor(
            window.HTMLInputElement.prototype,
            'value'
        )?.set;

        nativeValueSetter?.call(event.currentTarget, formattedValue);
        event.currentTarget.dispatchEvent(new Event('input', { bubbles: true }));
        event.currentTarget.dispatchEvent(new Event('change', { bubbles: true }));

        rest.onPaste?.(event);
    }

    return (
        <Styled.InputContainer>
            {label && (<label htmlFor={name}>{normalizedLabel}{required && ' *'}</label>)}
            {mask ? (
                <ReactInputMastk
                    id={name}
                    name={name}
                    className={errors[name] ? 'input-error' : ''}
                    errors={errors[name]}
                    type={normalizedInputType}
                    mask={mask}
                    maskChar=""
                    defaultValue={normalizedDefaultValue}
                    onPaste={handlePaste}
                    {...rest}
                >
                    {(inputProps: any) => 
                        <Styled.Input 
                            {...inputProps} 
                            errors={errors[name]}
                            autoComplete="off"
                            inputMode={type === 'email' ? undefined : 'numeric'}
                            required={required}
                            ref={register({
                                required: {
                                    value: required,
                                    message: errorMessage,
                                },
                                ...maskedMinLengthRule
                            })}
                        />}
                </ReactInputMastk>
            ) : (
                <Styled.Input
                    id={name} 
                    name={name}
                    className={errors[name] ? 'input-error' : ''} 
                    errors={errors[name]}
                    defaultValue={normalizedDefaultValue}
                    type={normalizedInputType} 
                    {...rest}
                    onPaste={rest.onPaste}
                    required={required}
                    ref={register({
                        required: {
                            value: required,
                            message: errorMessage
                        },
                        ...textMinLengthRule,
                        pattern: patt ? patt : null
                    })}
                />
            )}
            {errors[name] && <Styled.ErrorMessage className="input-error-message">{errors[name].message}</Styled.ErrorMessage>}
        </Styled.InputContainer>
    );
}
